module.exports = __webpack_public_path__ + "assets/img/life-1.75ffef0a.jpg";